import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { vamTitularesPolizas } from "./vam-titulares-polizas.component";
import { VamTitularesPolizasService } from "./vam-titulares-polizas.service";
import { DataTableModule } from "angular2-datatable";
import { CabeceraVAMModule } from "../../../components/common/cabeceraVAMTitulares/cabecera-vam-titulares.module";
import { VamTrackingComponent } from "../titulares/vam-tracking.component";
import { FilterDocumentos } from "./vam-titulares-polizas.pipe";
import { Ng2Bs3ModalModule } from '../../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal';
import { ApplicationPipesModule } from "../../../components/pipes/safe.module";

@NgModule({
    declarations: [vamTitularesPolizas, VamTrackingComponent, FilterDocumentos],
    imports: [BrowserModule, HttpModule,
        FormsModule,
        BrowserAnimationsModule,
        DataTableModule,
        CabeceraVAMModule,
        Ng2Bs3ModalModule,
        ApplicationPipesModule
      ],
    providers: [VamTitularesPolizasService]
})

export class VamTitularesPolizasModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/polizas/vam-titulares-polizas.module.ts